module.exports = __webpack_public_path__ + "static/img/bg.723362d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/bg.png
// module id = NLbk
// module chunks = 0